import { createContext } from 'react';

import { ContextValue, State } from './type';
import { getUser } from '../../utilities';

export const initialState: State = {
  user: getUser(),
};

const UserContext = createContext<ContextValue>({
  state: initialState,
  dispatch: () => {},
});

export default UserContext;
